import { create } from 'zustand';

interface DetailsState {
  // Открытая коммуна (comune-level панель).
  openIstat: string | null;
  // Открытый район (district-level панель: SLL / comunità comprensoriale).
  // Взаимоисключающе с openIstat — открыт максимум один.
  openDist: string | null;
  open: (istat: string) => void;
  openDistrict: (distCode: string) => void;
  close: () => void;
}

export const useDetailsStore = create<DetailsState>((set) => ({
  openIstat: null,
  openDist: null,
  open: (istat) => set({ openIstat: istat, openDist: null }),
  openDistrict: (distCode) => set({ openDist: distCode, openIstat: null }),
  close: () => set({ openIstat: null, openDist: null }),
}));
